import { render, staticRenderFns } from "./DetailTicket.vue?vue&type=template&id=53763cd5"
import script from "./DetailTicket.vue?vue&type=script&lang=ts"
export * from "./DetailTicket.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports